<template>
    <b-field>
        <template slot="label">
            Chart Type
        </template>
        <b-dropdown
            aria-role="list"
            v-model="dirtyChartType"
            @change="updateChartType"
            class="simple-dropdown"
            :disabled="isDisabled"
        >
            <button
                class="button simple-dropdown-button"
                slot="trigger"
                slot-scope="{ active }"
            >
                <span>{{ dirtyChartType }}</span>
                <b-icon
                    class="dropdown-arrow-icon-down"
                    type="is-black"
                    :icon="active? 'chevron-up' : 'chevron-down'"
                    size="is-small"
                ></b-icon>
            </button>
            <b-dropdown-item
                aria-role="listitem"
                v-for="(chart, chartIndex) in chartTypeList"
                :key="chartIndex"
                :value="chart"
                class="simple-dropdown-item"
            >
                {{ chart }}
            </b-dropdown-item>
        </b-dropdown>
    </b-field>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-property-decorator';
    import { cloneDeep as _cloneDeep } from 'lodash';
    import {ChartType} from '@/store/modules/audits/types/audits.types';

    @Component({ components : {} })

    export default class ChartTypeFilter extends Vue {
        @Prop({default: false})
        public isDisabled!: boolean;
        @Prop()
        public selectedChartType!: string;
        public dirtyChartType: string = '';

        public mounted() {
            this.dirtyChartType = this.selectedChartType;
        }

        public updateChartType(newValue: ChartType) {
            this.$emit('applyChartType', newValue);
        }

        get chartTypeList(): ChartType[] {
            return [ChartType.verticalBarChart, ChartType.horizontalBarChart];
        }
    }
</script>
<style lang="scss" module>
    .dropdownButton {
        background: #fbfbfb;
    }
    .divider {
        margin-top: unset;
        margin-bottom: unset;
        height: 1.5px;
        background-color: #dbdbdb;
    }
    .dropdownItem {
        padding-top: 10px;
        padding-left: 12px;
        padding-bottom: 10px;
        font-weight: 400;
        color: #444F51 !important;
    }
</style>
